import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToasterCustomService } from '@commons/services';
import { ToasterService } from '@commons/services';
import { CancelAsync } from './../../app/models/cancelAsync';
import { StatsService } from './../../app/services/stats.service';

import { ModalIframeComponent, ModalMarketingComponent } from '@app/modals';
import { ModalController, Platform } from '@ionic/angular';

import {
  AppInitService,
  ConfigUserService,
  NavigationService,
  PageLoaderService,
  PointsDeRendezVousService,
  PostalCodeService,
  StudentService,
} from '@app/services';

import { Student, StudentPurshasesDetails } from '@app/models';

import { google } from 'google-maps';

import { UtilsService } from '@commons/services';

import { EasyDebugDecorator } from '../../app/decorators/easy-debug.decorator';
import { environment } from '@app/env';

@EasyDebugDecorator
@Component({
  selector: 'gmap-new',
  templateUrl: 'gmap-new.page.html',
  styleUrls: ['gmap-new.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GmapNewPage extends CancelAsync implements OnInit {
  @ViewChild('gMap', { static: true }) mapElement: ElementRef;
  @ViewChild('sliderResults', { static: true }) sliderResults: ElementRef;
  @ViewChild('resultsDesktop', { static: true }) resultsDesktop: ElementRef;

  lockedFeatures = ['series/', 'statistiques'];

  pageTitle = 'Conduite';
  activeLink = 'conduite';

  iconPath = './uikit-assets/icons/orion-svg-sprite.svg#';

  initPageDone = false;

  isDesktop = window.innerWidth > 1023 ? true : false;
  isCordova = false;

  blocHeaderTitle = 'Nos points de rendez-vous';

  student: Student;
  userLifeCycle: any;
  configUser: any;

  longLoading = false;
  pageStart = Date.now();
  checkPageLoadingTimeInterval: any;

  // PAYMENTS GIFTS OFFERS
  studentPurshases: StudentPurshasesDetails;
  payments = [];
  gifts = [];
  coupons = [];
  paymentsGiftsCoupons: any = [];
  offers: any = [];
  fetchOffersFailed = false;
  studentCustomOffers: any = [];
  fetchStudentCustomOffersFailed = false;
  isPackPermis = false;
  isPackCode = false;
  isPackCodePremium = false;
  isHourOnly = false;
  hasHours = false;
  paymentsDone = false;

  isEngaged = false;

  packPermisUrl = 'https://www.envoituresimone.com/permis-de-conduire';

  stepChangeSub: any;
  pageLoaderSteps = [
    'init0',
    'init1',
    'init2',
    'init3',
    'init4',
    'init5',
    'initPage',
  ];
  hasMadeInit = false;

  navigationSubscription: any;

  geolocationLoading = false;
  noGeolocText = '';
  modalNoGeoloc = false;
  skipGeoloc = false;
  geolocFounded = false;
  modalLocationError = false;
  modalSearchError = false;

  map: any;
  mapLoaded = false;
  franceLocation = { lat: 46.927638, lng: 1.713749 };
  markers = [];
  infoWindow: any;
  infoWindowShown = false;
  currentLocationDone = false;
  lastZoom = null;

  autocomplete: any;
  placeLocationsSent = false;
  geocoder: any;

  userInput = '';
  userAddress = '';
  gearboxType = null;
  switchOffers = 'ALL';

  rawLocations = null;
  fetchLocationsFailed = false;
  fetchByCoordinatesFailed = false;
  fetchByLocationIdFailed = false;
  dispoResults: any = [];
  modalNoResults = false;
  addressInvalid = false;
  lastActiveCard = 0;
  lastActiveMarker = null;
  showResults = false;
  showResultsFullCards = false;
  cardsWidth = 280 + 12; // size + margin

  sliderType =
    window.innerWidth > (this.cardsWidth + 12) * 2 ? 'scroll' : 'swipe';
  dragStarted = false;
  posX = 0;
  decalX = 0;
  posY = 0;
  decalY = 0;
  oldDiffX = 0;
  lastAcc = 0;
  resetDecalX = false;
  marginLeft = 0;
  marginTop = 0;

  decelerateAnimInterval = null;

  limitSliderX = null;

  hideCnil = true;

  bounds = new google.maps.LatLngBounds();
  boundsPoints = [];

  zoomOptionsUpdated = false;

  /* querystring from website input search */
  queryLat: any;
  queryLng: any;

  @HostListener('window:resize', ['$event']) onResize(event) {
    this.isDesktop = window.innerWidth > 1023 ? true : false;
    this.sliderType =
      window.innerWidth > (this.cardsWidth + 12) * 2 ? 'scroll' : 'swipe';
    this.marginLeft = 0;
    if (
      !!this.sliderResults &&
      !!this.sliderResults.nativeElement &&
      !this.isDesktop
    ) {
      this.renderer.setStyle(
        this.sliderResults.nativeElement,
        'transform',
        'translateX(0)'
      );
    }
    setTimeout(() => {
      if (!this.isDesktop) {
        if (this.dispoResults.length === 1) {
          this.centerCardResult();
        }
        this.setHeightToCards();
      }
    }, 0);
  }

  constructor(
    private appInitService: AppInitService,
    public activatedRoute: ActivatedRoute,
    private pageLoaderService: PageLoaderService,
    private studentService: StudentService,
    private navigationService: NavigationService,
    public platform: Platform,
    private modalController: ModalController,
    private statsService: StatsService,
    private router: Router,
    private route: ActivatedRoute,
    public utils: UtilsService,
    public toasterService: ToasterService,
    public toasterCustomService: ToasterCustomService,
    private configUserService: ConfigUserService,
    private postalCodeService: PostalCodeService,
    private renderer: Renderer2,
    private pointsDeRendezVousService: PointsDeRendezVousService,
    private cdr: ChangeDetectorRef
  ) {
    super({ cancel: false, subscription: null });

    this.route.queryParams.subscribe(params => {
      this.queryLat = Number(params['lat']);
      this.queryLng = Number(params['lng']);
      // console.log('this.queryLat', this.queryLat);
      // console.log('this.queryLng', this.queryLng);
    });

    this.checkPageLoadingTimeInterval = setInterval(() => {
      const now = Date.now();
      // 3 sec
      if (now - this.pageStart >= 3000) {
        this.longLoading = true;
        clearInterval(this.checkPageLoadingTimeInterval);
      }
    }, 200);

    if (!this.appInitService.done) {
      this.navigationService.timestamp = Date.now();
      this.navigationService.lastLink = this.router.url.substr(1);
      this.hasMadeInit = true;
    } else {
      this.hasMadeInit = false;
    }

    // this.navigationSubscription = this.router.events.subscribe((e: any) => {
    //   // If it is a NavigationEnd event re-initalise the component
    //   if (e instanceof NavigationEnd) {
    //     if (!!this.navigationService.lastLink && this.navigationService.lastLink === this.router.url.substr(1)) {
    //       this.hasMadeInit = true;
    //       this.initPageDone = false;
    //       if (this.appInitService.done) {
    //         this.pageLoaderSteps = ['initApp', 'initPage'];
    //       } else {
    //         this.pageLoaderSteps = [
    //           'init0',
    //           'init1',
    //           'init2',
    //           'init3',
    //           'init4',
    //           'init5',
    //           'initPage',
    //         ];
    //       }
    //     }
    //   }
    // });

    this.activatedRoute.queryParams.subscribe(params => {
      const gearboxParam = params['gearbox_type'];
      this.gearboxType = !!gearboxParam ? gearboxParam : 'all';
      this.switchOffers = this.gearboxType.toUpperCase();
    });

    this.isCordova = this.platform.is('cordova');
    this.userLifeCycle = this.studentService.getUserLifeCycle(this.student); // if student not ready return guest
    if (this.appInitService.done) {
      this.pageLoaderSteps = ['initApp', 'initPage'];
      // this.pageLoaderService.setSteps(this.pageLoaderSteps.indexOf('initApp') + 1, this.pageLoaderSteps.length);
    }
    this.stepChangeSub = this.appInitService.onStepChange().subscribe(state => {
      if (state?.initDone) {
        if (!this.initPageDone) {
          this.initStudent();
        }
      }
    });
  }

  ionViewWillLeave() {
    // this.cancel = true;
    if (!!this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
    if (!!this.stepChangeSub) {
      this.stepChangeSub.unsubscribe();
    }
  }

  ngOnInit() {
    this.initPage();
  }

  async initPage() {
    // console.log('INITPAGE');
    this.mapInitializer();

    await this.fetchLocations();

    if (!!this.sliderResults && !!this.sliderResults.nativeElement) {
      this.sliderResults.nativeElement.addEventListener(
        'mousedown',
        (event: any) => {
          this.processMouseDown(event);
        }
      );
      this.sliderResults.nativeElement.addEventListener(
        'mousemove',
        (event: any) => {
          this.processMouseMove(event);
        }
      );
      window.addEventListener('mouseup', (event: any) => {
        this.processMouseUp(event);
      });
      this.sliderResults.nativeElement.addEventListener(
        'touchstart',
        (event: any) => {
          this.processMouseDown(event);
        }
      );
      this.sliderResults.nativeElement.addEventListener(
        'touchmove',
        (event: any) => {
          this.processMouseMove(event);
        }
      );
      window.addEventListener('touchend', (event: any) => {
        this.processMouseUp(event);
      });
    } else {
      console.log('Slider not yet available!');
    }

    // PAGE LOAD EVENT
    if (
      !!this.navigationService.timestamp &&
      !!this.navigationService.lastLink
    ) {
      const statObj = {
        page: this.navigationService.lastLink,
        loadTime: Date.now() - this.navigationService.timestamp,
        withInit: this.hasMadeInit,
      };
      if (this.statsService.isDebug) {
        console.log(statObj);
      }
      this.statsService.send({ name: 'page:view', payload: statObj });
    }

    // CF STATS MAXIME MORELLI
    // if (this.userLifeCycle.isUserGuest) {
    //   const item = {
    //     item_id: 'register',
    //     item_promo_type: 'regular',
    //     item_location_id: 'code_top',
    //     item_location_format: 'promo_card',
    //     item_promo_content: 'nouveaux_modes',
    //   };

    //   this.statsService.send({
    //     name: 'item:viewed', payload: {
    //       item: item
    //     }
    //   });
    // } else if (this.userLifeCycle.isUserRegistered) {
    //   const item = {
    //     item_id: 'big_pack',
    //     item_promo_type: 'regular',
    //     item_location_id: 'code_top',
    //     item_location_format: 'promo_card',
    //     item_promo_content: 'choucoute',
    //   };

    //   this.statsService.send({
    //     name: 'item:viewed', payload: {
    //       item: item
    //     }
    //   });
    // }
  }

  async initStudent() {
    this.initPageDone = true;
    this.student = this.studentService.student;
    this.userLifeCycle = this.studentService.getUserLifeCycle(this.student);
    this.configUser = await this.configUserService.getUserConfig(this.student);

    if (
      !this.userLifeCycle.isUserGuest &&
      !this.userLifeCycle.isUserRegistered
    ) {
      this.isEngaged = true;
    }

    this.getPayments();
    // generate offerId url
    if (!!this.offers) {
      this.getPackPermisUrl();
    }

    if (!this.mapLoaded) {
      this.initPage();
    }

    this.pageLoaderService.setSteps(
      this.pageLoaderSteps.indexOf('initPage') + 1,
      this.pageLoaderSteps.length
    );
    setTimeout(() => {
      this.pageLoaderService.stepsDone();
    }, 300);
  }

  getPayments() {
    this.studentPurshases = this.studentService.getStudentPurshases();

    const resGetOffers = this.studentPurshases.offers;
    if (
      !!resGetOffers &&
      !!resGetOffers.errorCode &&
      resGetOffers.errorCode === 'E301'
    ) {
      this.fetchOffersFailed = true;
    } else {
      this.offers = resGetOffers;
    }

    const resGetStudentCustomOffers = this.studentPurshases.studentCustomOffers;
    if (
      !!resGetStudentCustomOffers &&
      !!resGetStudentCustomOffers.errorCode &&
      resGetStudentCustomOffers.errorCode === 'E301'
    ) {
      this.fetchStudentCustomOffersFailed = true;
    } else {
      this.studentCustomOffers = resGetStudentCustomOffers;
    }
    this.gifts = this.studentPurshases.gifts;
    this.studentPurshases.linkOfferTopayment();
    this.studentPurshases.removeCouponsIfPresentInPayments();
    this.payments = this.studentPurshases.payments;
    this.coupons = this.studentPurshases.coupons;

    this.hasHours = this.studentPurshases.hasHours();
    this.isHourOnly = this.studentPurshases.isHourOnly();
    this.isPackCode = this.studentPurshases.isPackCode();
    this.isPackCodePremium = this.studentPurshases.isPackCodePremium();
    this.isPackPermis = this.studentPurshases.isPackPermis();

    const tmp = this.gifts.concat(this.coupons);
    this.paymentsGiftsCoupons = tmp.concat(this.payments);

    this.paymentsDone = true;
  }

  mapInitializer() {
    const zoomValue = window.innerWidth >= 768 ? 6 : 5;
    const styledMapType = new google.maps.StyledMapType(
      [
        {
          featureType: 'poi',
          elementType: 'labels',
          stylers: [{ visibility: 'off' }],
        },
      ],
      { name: 'Styled Map' }
    );

    // console.log(this.mapElement);
    this.map = new google.maps.Map(this.mapElement.nativeElement, {
      center: this.franceLocation,
      zoom: zoomValue,
      zoomControl: true,
      minZoom: 5,
      maxZoom: 18,
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_TOP,
      },
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
      mapTypeControlOptions: {
        mapTypeIds: ['roadmap', 'styled_map'],
      },
    });

    // Associate the styled map with the MapTypeId and set it to display.
    this.map.mapTypes.set('styled_map', styledMapType);
    this.map.setMapTypeId('styled_map');

    const options = {
      componentRestrictions: { country: 'fr' },
    };

    const input: any = document.getElementById('userInput');
    this.userAddress = input.value;
    this.autocomplete = new google.maps.places.Autocomplete(input, options);

    google.maps.event.addListener(this.autocomplete, 'place_changed', () => {
      input.blur();
      this.hideToasterInvalidAddress();
      this.removeUserPositionMarker();
      this.resetActiveMarker();
      this.geoCoding();
    });

    google.maps.event.addListener(this.map, 'zoom_changed', () => {
      input.blur();
      // console.log('zoom value', this.map.getZoom());
      this.lastZoom = this.map.getZoom();
    });

    window.addEventListener('wheel', (event: any) => {
      input.blur();
      if (!this.zoomOptionsUpdated) {
        // console.log('update setOptions on wheel');
        this.map.setOptions({
          minZoom: 5,
          maxZoom: 18,
        });
        this.zoomOptionsUpdated = true;
      }
    });
    window.addEventListener('touchstart', (event: any) => {
      // input.blur();
      if (!this.zoomOptionsUpdated) {
        // console.log('update setOptions on wheel');
        this.map.setOptions({
          minZoom: 5,
          maxZoom: 18,
        });
        this.zoomOptionsUpdated = true;
      }
    });

    this.geocoder = new google.maps.Geocoder();

    this.infoWindow = new google.maps.InfoWindow({
      content: '',
      disableAutoPan: true,
    });

    this.map.addListener('click', (event: any) => {
      input.blur();
      if (this.infoWindowShown) {
        this.infoWindow.close();
        this.infoWindowShown = false;
      }
      this.reduceCards();
    });

    this.map.addListener('dragstart', () => {
      input.blur();
      if (this.infoWindowShown) {
        this.infoWindow.close();
        this.infoWindowShown = false;
      }
      this.reduceCards();
    });

    google.maps.event.addListenerOnce(this.map, 'tilesloaded', () => {
      this.mapLoaded = true;
      if (!!this.queryLat && !!this.queryLng) {
        this.fetchFromQueryString();
      }
      this.cdr.detectChanges();
    });
  }

  newBounds() {
    this.bounds = new google.maps.LatLngBounds();
    this.boundsPoints = [];
  }

  addToBounds(lat: any, lng: any) {
    this.boundsPoints.push(new google.maps.LatLng(lat, lng));
  }

  processBounds() {
    // console.log('processBounds', this.boundsPoints);
    for (let i = 0, len = this.boundsPoints.length; i < len; i++) {
      this.bounds.extend(this.boundsPoints[i]);
    }
  }

  fitBounds() {
    if (this.boundsPoints.length === 1) {
      this.map.setOptions({
        minZoom: 11,
        maxZoom: this.map.getZoom() >= 11 ? this.map.getZoom() : 16,
      });
      this.zoomOptionsUpdated = false;
      this.lastZoom = this.map.getZoom() !== 14 ? this.map.getZoom() : 14;
    } else {
      // console.log('setOptions 18');
      this.map.setOptions({
        minZoom: 5,
        maxZoom: 18,
      });
      this.zoomOptionsUpdated = true;
    }
    const paddingBounds = this.isDesktop ? 50 : 50;
    const paddingTopBounds = this.isDesktop ? 50 : 50;
    const paddingLeftBounds = this.isDesktop ? 432 : 50;
    const paddingBottomBounds = this.isDesktop ? 0 : 320;
    const paddingRightBounds = this.isDesktop ? 50 : 50;
    // console.log({bottom: paddingBottomBounds, top: paddingTopBounds, left: paddingLeftBounds, right: paddingRightBounds});
    this.map.fitBounds(this.bounds, {
      bottom: paddingBottomBounds,
      top: paddingTopBounds,
      left: paddingLeftBounds,
      right: paddingRightBounds,
    });

    if (this.boundsPoints.length === 1) {
      const middleMapH = this.mapElement.nativeElement.offsetHeight / 2;
      const middleMapW = this.mapElement.nativeElement.offsetWidth / 2;
      const cardHeight = this.showResultsFullCards ? 307 : 140;
      const middleVisibleZone =
        (this.mapElement.nativeElement.offsetHeight - cardHeight) / 2;
      const offsetYMap = middleMapH - middleVisibleZone - 20; // 20 = pin /2
      const offsetXMap = middleMapW + 216 - 20; // 20 = pin /2
      // console.log('middleMap', middleMap);
      // console.log('middleVisibleZone', middleVisibleZone);
      // console.log('offsetYMap = middleMap - middleVisibleZone', offsetYMap);
      if (!this.isDesktop) {
        // set center above cards
        this.map.panBy(0, offsetYMap);
      } else {
        this.map.panBy(offsetXMap, 0);
      }
    }
  }

  async fetchLocations() {
    const resFetchLocations = await this.pointsDeRendezVousService
      .fetchLocations(this.gearboxType)
      .toPromise();
    if (
      !!resFetchLocations &&
      !!resFetchLocations.errorCode &&
      resFetchLocations.errorCode === 'E301'
    ) {
      this.fetchLocationsFailed = true;
      this.showModalLocationError();
    } else {
      this.rawLocations = resFetchLocations;
    }
    // console.log('fetchLocations', this.rawLocations);
    this.addLocations();
  }

  addLocations() {
    if (!!this.rawLocations && this.rawLocations.length > 0) {
      for (let i = 0, len = this.rawLocations.length; i < len; i++) {
        if (!!this.rawLocations[i] && !!this.rawLocations[i].active) {
          this.addMarker({
            location: this.rawLocations[i],
            position: {
              lat: this.rawLocations[i].coordinates[1],
              lng: this.rawLocations[i].coordinates[0],
            },
          });
        }
      }
    }
  }

  fetchByLocationId(location: any, marker?: any) {
    let markerPos = null;
    if (!!marker) {
      markerPos = marker.getPosition();
    }
    const cardAlreadyInResults = this.dispoResults.find(
      elt => elt.address === location.name
    );
    // console.log('cardAlreadyInResults', cardAlreadyInResults);
    if (!cardAlreadyInResults) {
      this.pointsDeRendezVousService
        .fetchByLocationId(location.id, this.gearboxType)
        .subscribe(
          (res: any) => {
            if (!!res && !!res.errorCode && res.errorCode === 'E301') {
              this.fetchByLocationIdFailed = true;
            }
            if (!this.fetchByLocationIdFailed) {
              // console.log('fetchByLocationId', res);
              this.hideCnil = true;
              if (!this.placeLocationsSent) {
                this.dispoResults = [];
              }
              const horaires = [];
              const teachers = [];
              const orderedDays = [
                '1-Monday',
                '2-Tuesday',
                '3-Wednesday',
                '4-Thursday',
                '5-Friday',
                '6-Saturday',
                '0-Sunday',
              ];
              // const sortedDayOfWeek = res[i].day_of_week.sort((a: any, b: any) => a.key.localeCompare(b.name));
              for (let d = 0, lend = orderedDays.length; d < lend; d++) {
                let cleanDay = '';
                const findDayInWeek = res.day_of_week.find(
                  elt => elt.key === orderedDays[d]
                );
                switch (orderedDays[d]) {
                  case '0-Sunday':
                    cleanDay = 'DIM';
                    break;
                  case '1-Monday':
                    cleanDay = 'LUN';
                    break;
                  case '2-Tuesday':
                    cleanDay = 'MAR';
                    break;
                  case '3-Wednesday':
                    cleanDay = 'MER';
                    break;
                  case '4-Thursday':
                    cleanDay = 'JEU';
                    break;
                  case '5-Friday':
                    cleanDay = 'VEN';
                    break;
                  case '6-Saturday':
                    cleanDay = 'SAM';
                    break;
                }
                horaires.push({
                  day: cleanDay,
                  horaire: !!findDayInWeek
                    ? findDayInWeek.min_hour + ' - ' + findDayInWeek.max_hour
                    : '-',
                });
              }
              let gearboxTypeOnLocation = null;
              if (res.teachers.length > 0) {
                for (let t = 0, lent = res.teachers.length; t < lent; t++) {
                  // ajouter la rule de si res.teachers[t].nb_rating < 50 on affiche nouveau
                  // check avec le produit comment on affiche ça au pire
                  const optimizedImg =
                    !!res.teachers[t].picture_url &&
                    res.teachers[t].picture_url !== 'missing_avatar.png'
                      ? res.teachers[t].picture_url.replace('original', 'thumb')
                      : 'assets/img/default-avatar.png';
                  teachers.push({
                    image: optimizedImg,
                    name: res.teachers[t].first_name,
                    carModel: res.teachers[t].car_model,
                    note: res.teachers[t].rating,
                    notes: res.teachers[t].nb_rating,
                    gearboxType: !!res.teachers[t].automatic_car
                      ? 'BVA'
                      : 'BVM',
                  });

                  const teacherGearBoxType = !!res.teachers[t].automatic_car
                    ? 'BVA'
                    : 'BVM';

                  if (!gearboxTypeOnLocation) {
                    gearboxTypeOnLocation = teacherGearBoxType;
                  } else {
                    gearboxTypeOnLocation =
                      gearboxTypeOnLocation === teacherGearBoxType
                        ? gearboxTypeOnLocation
                        : 'ALL';
                  }
                }
              }
              if (!this.placeLocationsSent) {
                this.dispoResults.push({
                  address: location.name,
                  distance: null,
                  itemActive: 'horaires',
                  horaires: horaires,
                  teachers: teachers,
                  data: location,
                  gearboxTypeOnLocation: gearboxTypeOnLocation,
                });
              } else {
                // reset lastActiveCard
                this.lastActiveCard =
                  !this.lastActiveCard || this.lastActiveCard === 0
                    ? 0
                    : this.lastActiveCard;
                this.dispoResults[this.lastActiveCard].active = false;
                this.lastActiveCard = 0;

                // add new location to first index of array
                this.dispoResults.unshift({
                  address: location.name,
                  distance: null,
                  itemActive: 'horaires',
                  horaires: horaires,
                  teachers: teachers,
                  data: location,
                  gearboxTypeOnLocation: gearboxTypeOnLocation,
                });
                if (!!this.resultsDesktop && this.isDesktop) {
                  // scroll to top of div
                  setTimeout(() => {
                    this.resultsDesktop.nativeElement.scrollTop = 0;
                  }, 0);
                } else {
                  // console.log('center new marker', location);
                  if (!!markerPos) {
                    this.centerMap(markerPos.lat(), markerPos.lng());
                  }
                }
              }
              this.setSliderResults();
              // console.log('placeLocationsSent', this.placeLocationsSent);
              if (!this.placeLocationsSent) {
                // console.log('show only marker clicked (with no search)');
                if (!!markerPos) {
                  this.centerMap(markerPos.lat(), markerPos.lng());
                }
              }
            } else {
              this.showModalSearchError();
            }
            this.cdr.detectChanges();
          },
          error => {
            console.error(
              'PointsDeRendezVousPage: fetchByLocationId error => ' +
                JSON.stringify(error)
            );
          }
        );
    } else {
      // console.log('point already exist');
      const indexOfLocationInResults = this.dispoResults.findIndex(
        elt => elt === cardAlreadyInResults
      );
      this.lastActiveCard =
        !this.lastActiveCard || this.lastActiveCard === 0
          ? 0
          : this.lastActiveCard;
      this.dispoResults[this.lastActiveCard].active = false;
      this.lastActiveCard = indexOfLocationInResults;
      this.dispoResults[indexOfLocationInResults].active = true;

      if (!!markerPos) {
        this.centerMap(markerPos.lat(), markerPos.lng());
      }

      this.updateMarker();

      if (!this.isDesktop) {
        this.goToClosestCard(indexOfLocationInResults);
      } else {
        const parent = document.getElementById('results-desktop');
        const elt: any =
          parent.getElementsByClassName('card-result')[
            indexOfLocationInResults
          ];
        setTimeout(() => {
          this.resultsDesktop.nativeElement.scrollTop = elt.offsetTop - 16;
        }, 0);
      }
      this.cdr.detectChanges();
    }
  }

  fetchByCoordinates(lat: any, lng: any) {
    this.pointsDeRendezVousService
      .fetchByCoordinates(lat, lng, false, this.gearboxType)
      .subscribe(
        res => {
          this.hideCnil = true;
          // console.log('fetchByCoordinates res', res);
          if (!!res && !!res.errorCode && res.errorCode === 'E301') {
            this.fetchByCoordinatesFailed = true;
          }
          if (this.fetchByCoordinatesFailed) {
            this.showModalSearchError();
          } else if (!!res && res.length > 0) {
            this.resetActiveMarker();
            // add current position from lat lng search
            this.addMarker({ position: { lat: lat, lng: lng } }, false, true);

            this.newBounds();
            this.addToBounds(lat, lng);

            this.marginLeft = 0; // reset slider
            this.renderer.setStyle(
              this.sliderResults.nativeElement,
              'transition',
              'transform .3s ease-out'
            );
            this.renderer.setStyle(
              this.sliderResults.nativeElement,
              'transform',
              'translateX(' + this.marginLeft + 'px)'
            );
            this.dispoResults = [];
            this.showResultsFullCards = false;
            this.cdr.detectChanges();
            const sortedByDistance = res.sort(
              (a: any, b: any) => a.location.distance - b.location.distance
            );
            for (let i = 0, len = sortedByDistance.length; i < len; i++) {
              if (i < 5) {
                this.addToBounds(
                  sortedByDistance[i].location.coordinates[1],
                  sortedByDistance[i].location.coordinates[0]
                );
              }
              const horaires = [];
              const teachers = [];
              if (sortedByDistance[i].day_of_week.length > 0) {
                const orderedDays = [
                  '1-Monday',
                  '2-Tuesday',
                  '3-Wednesday',
                  '4-Thursday',
                  '5-Friday',
                  '6-Saturday',
                  '0-Sunday',
                ];
                // const sortedDayOfWeek = res[i].day_of_week.sort((a: any, b: any) => a.key.localeCompare(b.name));
                for (let d = 0, lend = orderedDays.length; d < lend; d++) {
                  let cleanDay = '';
                  const findDayInWeek = sortedByDistance[i].day_of_week.find(
                    elt => elt.key === orderedDays[d]
                  );
                  switch (orderedDays[d]) {
                    case '0-Sunday':
                      cleanDay = 'DIM';
                      break;
                    case '1-Monday':
                      cleanDay = 'LUN';
                      break;
                    case '2-Tuesday':
                      cleanDay = 'MAR';
                      break;
                    case '3-Wednesday':
                      cleanDay = 'MER';
                      break;
                    case '4-Thursday':
                      cleanDay = 'JEU';
                      break;
                    case '5-Friday':
                      cleanDay = 'VEN';
                      break;
                    case '6-Saturday':
                      cleanDay = 'SAM';
                      break;
                  }
                  horaires.push({
                    day: cleanDay,
                    horaire: !!findDayInWeek
                      ? findDayInWeek.min_hour + ' - ' + findDayInWeek.max_hour
                      : '-',
                  });
                }
              }
              let gearboxTypeOnLocation = null;
              if (sortedByDistance[i].teachers.length > 0) {
                for (
                  let t = 0, lent = sortedByDistance[i].teachers.length;
                  t < lent;
                  t++
                ) {
                  // ajouter la rule de si sortedByDistance[i].teachers[t].nb_rating < 50 on affiche nouveau
                  // check avec le produit comment on affiche ça au pire
                  const optimizedImg =
                    !!sortedByDistance[i].teachers[t].picture_url &&
                    sortedByDistance[i].teachers[t].picture_url !==
                      'missing_avatar.png'
                      ? sortedByDistance[i].teachers[t].picture_url.replace(
                          'original',
                          'thumb'
                        )
                      : 'assets/img/default-avatar.png';
                  teachers.push({
                    image: optimizedImg,
                    name: sortedByDistance[i].teachers[t].first_name,
                    carModel: sortedByDistance[i].teachers[t].car_model,
                    note: sortedByDistance[i].teachers[t].rating,
                    notes: sortedByDistance[i].teachers[t].nb_rating,
                    gearboxType: !!sortedByDistance[i].teachers[t].automatic_car
                      ? 'BVA'
                      : 'BVM',
                  });

                  const teacherGearBoxType = !!sortedByDistance[i].teachers[t]
                    .automatic_car
                    ? 'BVA'
                    : 'BVM';

                  if (!gearboxTypeOnLocation) {
                    gearboxTypeOnLocation = teacherGearBoxType;
                  } else {
                    gearboxTypeOnLocation =
                      gearboxTypeOnLocation === teacherGearBoxType
                        ? gearboxTypeOnLocation
                        : 'ALL';
                  }
                }
              }
              let cleanDistance = 0 + 'm';
              if (sortedByDistance[i].location.distance < 1) {
                cleanDistance =
                  sortedByDistance[i].location.distance.toFixed(3).substr(2) +
                  'm';
                if (cleanDistance.charAt(0) === '0') {
                  // 039m
                  cleanDistance = cleanDistance.substr(1); // 39m
                }
                if (cleanDistance.charAt(0) === '0') {
                  // 009m
                  cleanDistance = cleanDistance.substr(1); // 9m
                }
              } else {
                cleanDistance =
                  sortedByDistance[i].location.distance.toFixed(1) + 'km';
                if (cleanDistance.substr(-3) === '0km') {
                  cleanDistance = cleanDistance.slice(0, -4) + 'km';
                }
              }
              this.dispoResults.push({
                address: sortedByDistance[i].location.name,
                distance: cleanDistance,
                itemActive: 'horaires',
                horaires: horaires,
                teachers: teachers,
                data: sortedByDistance[i],
                gearboxTypeOnLocation: gearboxTypeOnLocation,
              });
            }
            this.dispoResults[0].active = true;
            // console.log('fetchByCoordinates dispoResults', this.dispoResults);
            this.cdr.detectChanges();
            this.processBounds();
            this.fitBounds();

            setTimeout(() => {
              this.resultsDesktop.nativeElement.scrollTop = 0;
            }, 0);
            this.setSliderResults();
          } else {
            this.showModalNoResults();
          }
          this.cdr.detectChanges();
        },
        error => {
          console.error(
            'PointsDeRendezVousPage: fetchByLocationId error => ' +
              JSON.stringify(error)
          );
        }
      );
  }

  resetInput() {
    const input: any = document.getElementById('userInput');
    // this.hideCnil = false;
    this.showResults = false;
    input.value = '';
    if (this.placeLocationsSent) {
      this.dispoResults = [];
      this.showResultsFullCards = false;
      this.map.setOptions({
        minZoom: 5,
        maxZoom: 18,
      });
      const zoomValue = window.innerWidth >= 768 ? 6 : 5;
      this.map.setZoom(zoomValue);
      this.map.panTo(this.franceLocation);
    }
    if (this.modalNoResults) {
      this.modalNoResults = false;
    }
    this.hideToasterInvalidAddress();
    this.removeUserPositionMarker();
    this.resetActiveMarker();
    this.placeLocationsSent = false;
    input.focus();
    this.cdr.detectChanges();
    setTimeout(() => {
      this.userAddress = '';
      this.cdr.detectChanges();
    }, 200);
  }

  resetActiveMarker() {
    this.updateMarker(true);
    this.infoWindow.close();
    this.infoWindowShown = false;
    this.cdr.detectChanges();
  }

  removeUserPositionMarker() {
    const markerUserLocation = this.markers.find(elt => elt.userPosition);
    const markerUserLocationIndex = this.markers.findIndex(
      elt => elt.userPosition
    );
    if (!!markerUserLocation) {
      google.maps.event.clearListeners(
        this.markers[markerUserLocationIndex],
        'click'
      );
      this.markers.splice(markerUserLocationIndex, 1);
      markerUserLocation.setMap(null);
    }
    this.infoWindow.close();
    this.infoWindowShown = false;
    this.cdr.detectChanges();
  }

  setSliderResults() {
    // console.log('this.mapLoaded', this.mapLoaded);
    if (this.mapLoaded) {
      // set first card active
      if (this.dispoResults.length > 0) {
        this.dispoResults[0].active = true;
        this.lastActiveCard = 0;
        this.marginLeft = 0;
        if (
          !!this.sliderResults &&
          !!this.sliderResults.nativeElement &&
          !this.isDesktop
        ) {
          this.renderer.setStyle(
            this.sliderResults.nativeElement,
            'transform',
            'translateX(0)'
          );
        }
        this.updateMarker();
        this.showResults = true;
        // console.log(this.dispoResults);
        this.cdr.detectChanges();
        setTimeout(() => {
          if (this.dispoResults.length === 1) {
            this.centerCardResult();
          }
          this.setHeightToCards();
        }, 0);
      }
    }
  }

  centerCardResult() {
    this.marginLeft = (window.innerWidth - (this.cardsWidth + 12)) / 2;
    this.renderer.setStyle(
      this.sliderResults.nativeElement,
      'transition',
      'transform .3s ease-out'
    );
    this.renderer.setStyle(
      this.sliderResults.nativeElement,
      'transform',
      'translateX(' + this.marginLeft + 'px)'
    );
    this.cdr.detectChanges();
  }

  setHeightToCards() {
    if (!!this.sliderResults && !!this.sliderResults.nativeElement) {
      const cards: any =
        this.sliderResults.nativeElement.getElementsByClassName(
          'elements-to-hide'
        );
      for (let i = 0; i < cards.length; i++) {
        const height = cards[i].offsetHeight;
        if (!!height && height > 0) {
          cards[i].style.height = height + 'px';
          this.dispoResults[i].cardHeight = height + 'px';
        }
      }
      this.cdr.detectChanges();
    } else {
      console.log('Slider not yet available!');
    }
  }

  addMarker(
    markerProperties: any,
    showInfowWindow = false,
    userPosition = false
  ) {
    const markerSettings: any = {};
    markerSettings.position = markerProperties.position;
    markerSettings.animation = google.maps.Animation.DROP;
    if (userPosition) {
      markerSettings.icon =
        'https://app.envoituresimone.com/assets/png/pin-location.png';
    } else {
      markerSettings.icon =
        'https://app.envoituresimone.com/assets/png/pin-default.png';
    }
    let markerTitle = '';
    if (userPosition) {
      markerTitle = 'Tu es ici';
    } else {
      markerTitle = markerProperties.location.name;
      if (!!markerProperties.location.distance) {
        let cleanDistance = 0 + 'm';
        if (markerProperties.location.distance < 1) {
          cleanDistance =
            markerProperties.location.distance.toFixed(3).substr(2) + 'm';
          if (cleanDistance.charAt(0) === '0') {
            // 039m
            cleanDistance = cleanDistance.substr(1); // 39m
          }
          if (cleanDistance.charAt(0) === '0') {
            // 009m
            cleanDistance = cleanDistance.substr(1); // 9m
          }
        } else {
          cleanDistance = markerProperties.location.distance.toFixed(1) + 'km';
          if (cleanDistance.substr(-3) === '0km') {
            cleanDistance = cleanDistance.slice(0, -4) + 'km';
          }
        }
        markerTitle += ' - ' + cleanDistance;
      }
    }
    markerSettings.title = markerTitle;
    if (userPosition) {
      markerSettings.userPosition = true;
    }
    const marker: any = new google.maps.Marker(markerSettings);
    marker.setMap(this.map); // add to map

    // addlisteners
    marker.addListener('mouseover', () => {
      this.showInfoWindow(marker);
      // if (!marker.userPosition) {
      //   marker.setAnimation(google.maps.Animation.BOUNCE);
      // }
    });
    marker.addListener('mouseout', () => {
      // marker.setAnimation(null);
      if (this.infoWindowShown) {
        this.infoWindow.close();
        this.infoWindowShown = false;
      }
    });
    marker.addListener('click', () => {
      const input: any = document.getElementById('userInput');
      input.blur();
      // console.log('this.markers', this.markers);
      // console.log('marker', marker);
      // console.log('this.lastActiveMarker', this.lastActiveMarker);
      const findMarker = this.markers.find(elt => elt === marker);
      if (findMarker !== this.lastActiveMarker) {
        if (!!findMarker && !marker.userPosition) {
          if (!!this.lastActiveMarker) {
            this.lastActiveMarker.setIcon(
              'https://app.envoituresimone.com/assets/png/pin-default.png'
            );
          }
          findMarker.setIcon(
            'https://app.envoituresimone.com/assets/png/pin-active.png'
          );
          this.lastActiveMarker = marker;
        }
        if (marker.userPosition) {
          this.showInfoWindow(marker);
        }
        if (!marker.userPosition) {
          this.showResultsFullCards = true;
          this.cdr.detectChanges();
          this.fetchByLocationId(markerProperties.location, marker);
        }
      } else {
        this.updateZoom();
        this.centerMap(marker.position.lat(), marker.position.lng());
      }
    });

    if (showInfowWindow) {
      this.centerMap(marker.lat(), marker.lng());
      this.showInfoWindow(marker);
    }

    this.markers.push(marker);
  }

  updateZoom() {
    // console.log(this.map.getZoom(), this.lastZoom);
    if (this.map.getZoom() < this.lastZoom) {
      this.map.setZoom(this.lastZoom);
    }
  }

  updateMarker(reset?: boolean) {
    // console.log('updateMarker reset', reset);
    // console.log('updateMarker this.lastActiveMarker', this.lastActiveMarker);
    if (
      !!this.dispoResults &&
      this.dispoResults.length > 0 &&
      !!this.dispoResults[this.lastActiveCard] &&
      !!this.dispoResults[this.lastActiveCard].data &&
      !!this.markers &&
      this.markers.length > 0 &&
      (!!this.lastActiveCard || this.lastActiveCard === 0)
    ) {
      const lat = !!this.dispoResults[this.lastActiveCard].data.location
        ? this.dispoResults[this.lastActiveCard].data.location.coordinates[1]
        : this.dispoResults[this.lastActiveCard].data.coordinates[1];
      const lng = !!this.dispoResults[this.lastActiveCard].data.location
        ? this.dispoResults[this.lastActiveCard].data.location.coordinates[0]
        : this.dispoResults[this.lastActiveCard].data.coordinates[0];
      const findMarker = this.markers.find(
        elt => elt.position.lat() === lat && elt.position.lng() === lng
      );
      if (!!findMarker) {
        // const indexOfMarker = findMarker.findIndex(elt => elt === findMarker);
        if (!!this.lastActiveMarker) {
          this.lastActiveMarker.setIcon(
            'https://app.envoituresimone.com/assets/png/pin-default.png'
          );
        }
        findMarker.setIcon(
          'https://app.envoituresimone.com/assets/png/pin-active.png'
        );
        this.lastActiveMarker = findMarker;
      } else {
        console.log('Marker not found!');
      }
    }
    if (reset) {
      for (let i = 0, len = this.markers.length; i < len; i++) {
        this.markers[i].setIcon(
          'https://app.envoituresimone.com/assets/png/pin-default.png'
        );
      }
    }
  }

  fetchFromQueryString() {
    if (!!this.queryLat && !!this.queryLng) {
      // console.log('fetchFromQueryString', typeof this.queryLat, typeof this.queryLng);
      this.geocoder.geocode(
        { location: { lat: this.queryLat, lng: this.queryLng } },
        (results: any, status: any) => {
          // console.log('results', results);
          // console.log('status', status);
          if (status === 'OK') {
            if (results[0]) {
              if (!!results[0].formatted_address) {
                const address: any = document.getElementById('userInput');
                address.value = results[0].formatted_address;
                this.placeLocationsSent = true;
              }
              this.cdr.detectChanges();
              this.fetchByCoordinates(this.queryLat, this.queryLng);
            } else {
              this.geolocFounded = false;
              this.noGeolocText =
                'Nous ne sommes pas parvenus à récupérer ton addresse !';
              this.cdr.detectChanges();
              this.showModalNoGeoloc();
            }
          } else {
            this.geolocationLoading = false;
            this.skipGeoloc = true;
            this.geolocFounded = false;
            this.noGeolocText =
              'Nous ne sommes pas parvenus à récupérer ton position !';
            this.cdr.detectChanges();
            this.showModalNoGeoloc();
          }
        }
      );
    }
  }

  showCurrentLocation() {
    if (!this.geolocationLoading) {
      const input: any = document.getElementById('userInput');
      this.skipGeoloc = false;
      this.geolocFounded = false;
      if (navigator.geolocation && 'geolocation' in navigator) {
        this.geolocationLoading = true;
        setTimeout(() => {
          this.geolocationLoading = false;
          if (!this.skipGeoloc && !this.geolocFounded) {
            this.skipGeoloc = true;
            this.geolocFounded = false;
            this.noGeolocText =
              'Nous ne sommes pas parvenus à récupérer ta position !';
            this.showModalNoGeoloc();
            this.cdr.detectChanges();
          }
        }, 5000);
        // ya un prob avec ce truc des fois il se lance mais ne fait rien d'autre ni confirmation ni erreur
        navigator.geolocation.getCurrentPosition(
          (position: any) => {
            this.geolocFounded = true;
            this.skipGeoloc = false;
            if (!this.skipGeoloc) {
              this.hideCnil = true;
              this.geolocationLoading = false;
              // console.log(position);
              const pos = {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
              };
              this.cdr.detectChanges();
              // this.map.panTo(pos);
              // this.map.setZoom(16);
              // if (!this.currentLocationDone) {
              //   this.addMarker({position: pos}, true, true);
              //   this.currentLocationDone = true;
              // } else {
              //   const userMarker = this.markers.find(elt => elt.title === 'Tu es ici');
              //   this.showInfoWindow(userMarker);
              // }
              this.geocoder.geocode(
                { location: pos },
                (results: any, status: any) => {
                  // console.log('results', results);
                  // console.log('status', status);
                  if (status === 'OK') {
                    if (results[0]) {
                      if (!!results[0].formatted_address) {
                        const address: any =
                          document.getElementById('userInput');
                        address.value = results[0].formatted_address;
                        this.placeLocationsSent = true;
                      }
                      this.geolocationLoading = false;
                      this.cdr.detectChanges();
                      this.fetchByCoordinates(pos.lat, pos.lng);
                    } else {
                      this.geolocationLoading = false;
                      this.skipGeoloc = true;
                      this.geolocFounded = false;
                      this.noGeolocText =
                        'Nous ne sommes pas parvenus à récupérer ta position !';
                      this.cdr.detectChanges();
                      this.showModalNoGeoloc();
                    }
                  } else {
                    this.geolocationLoading = false;
                    this.skipGeoloc = true;
                    this.geolocFounded = false;
                    this.noGeolocText =
                      'Nous ne sommes pas parvenus à récupérer ta position !';
                    this.cdr.detectChanges();
                    this.showModalNoGeoloc();
                  }
                }
              );
            }
          },
          () => {
            this.geolocationLoading = false;
            this.geolocFounded = false;
            this.cdr.detectChanges();
            if (!this.skipGeoloc) {
              this.skipGeoloc = true;
              this.noGeolocText =
                'Nous ne sommes pas parvenus à récupérer ta position !';
              this.cdr.detectChanges();
              this.showModalNoGeoloc();
            }
          }
        );
      } else {
        this.geolocationLoading = false;
        this.geolocFounded = false;
        this.cdr.detectChanges();
        if (!this.skipGeoloc) {
          this.noGeolocText =
            'Ton navigateur ne supporte pas la Geolocalisation!';
          this.cdr.detectChanges();
          this.showModalNoGeoloc();
        }
      }
    }
  }

  centerMap(lat: any, lng: any) {
    if (this.isDesktop) {
      // console.log('panTo');
      if (!this.placeLocationsSent && this.map.getZoom() !== 12) {
        this.map.setZoom(12);
      }
      this.map.panTo({ lat: lat, lng: lng });
      this.map.panBy(-200, 0); // 200 - 16
    } else {
      // console.log('centerMap');
      this.newBounds();
      this.addToBounds(lat, lng);
      this.processBounds();
      this.fitBounds();
    }
  }

  showInfoWindow(marker: any) {
    const contentString = marker.title;
    if (this.infoWindowShown) {
      this.infoWindow.close();
      this.infoWindowShown = false;
    }
    this.infoWindow = new google.maps.InfoWindow({
      content: contentString,
      disableAutoPan: true,
    });
    this.infoWindow.open(this.map, marker);
    this.infoWindowShown = true;
    this.cdr.detectChanges();
  }

  setMapOnAll(map: any) {
    for (let i = 0; i < this.markers.length; i++) {
      this.markers[i].setMap(map);
    }
    this.cdr.detectChanges();
  }

  showMarkers() {
    this.setMapOnAll(this.map);
  }

  clearMarkers() {
    this.setMapOnAll(null);
    this.infoWindowShown = false;
    this.cdr.detectChanges();
  }

  deleteMarkers() {
    this.clearMarkers();
    this.markers = [];
    this.infoWindowShown = false;
  }

  geoCoding() {
    this.geolocationLoading = false;
    this.placeLocationsSent = true;
    const address: any = document.getElementById('userInput');
    this.userAddress = address.value;
    this.cdr.detectChanges();
    if (!!address && !!address.value && address.value !== '') {
      this.geocoder.geocode(
        { address: address.value },
        (results: any, status: any) => {
          // console.log(results);
          if (status === 'OK') {
            this.hideToasterInvalidAddress();
            // console.log(results[0].formatted_address + '\nlat: ' + results[0].geometry.location.lat() + ' long: ' + results[0].geometry.location.lng());
            this.fetchByCoordinates(
              results[0].geometry.location.lat(),
              results[0].geometry.location.lng()
            );
          } else {
            this.showToasterInvalidAddress();
          }
        }
      );
    }
  }

  setActiveItem(index: any, itemActive: any) {
    // console.log(index, itemActive);
    this.dispoResults[index].itemActive = itemActive;
    const cards: any =
      this.sliderResults.nativeElement.getElementsByClassName(
        'elements-to-hide'
      );
    cards[index].style.height = 'inherit';
    this.dispoResults[index].cardHeight = null;
    this.cdr.detectChanges();
    setTimeout(() => {
      const height = cards[index].offsetHeight;
      if (!!height && height > 0) {
        cards[index].style.height = height + 'px';
        this.dispoResults[index].cardHeight = height;
      }
      this.cdr.detectChanges();
    }, 0);
  }

  processMouseDown(event: any) {
    if (!!this.decelerateAnimInterval) {
      clearInterval(this.decelerateAnimInterval);
    }
    this.renderer.setStyle(
      this.sliderResults.nativeElement,
      'transition',
      'none'
    );
    if (this.dispoResults.length > 0) {
      this.limitSliderX =
        (this.dispoResults.length * 280 +
          (this.dispoResults.length - 1) * 12 +
          24 -
          window.innerWidth) *
        -1;
      this.posX = this.utils.unify(event).clientX;
      this.decalX = 0;
      this.posY = this.utils.unify(event).clientY;
      this.decalY = 0;
      this.lastAcc = 0;
      this.dragStarted = true;
    }
  }
  processMouseMove(event: any) {
    if (this.dragStarted) {
      event.preventDefault(); // prevent page scrolling
      const diffX = this.utils.unify(event).clientX - this.posX;
      const diffY = this.utils.unify(event).clientY - this.posY;
      if (Math.abs(diffX) > Math.abs(diffY) && this.dispoResults.length > 1) {
        if (diffX !== 0) {
          this.resetDecalX = true;
          this.decalX = this.marginLeft + diffX;
          this.decalX = this.decalX > 0 ? 0 : this.decalX;
          this.decalX =
            this.decalX <= this.limitSliderX ? this.limitSliderX : this.decalX;
          if (this.decalX <= 0 && this.decalX >= this.limitSliderX) {
            this.lastAcc = this.oldDiffX - diffX;
            this.oldDiffX = diffX;
            this.renderer.setStyle(
              this.sliderResults.nativeElement,
              'transform',
              'translateX(' + this.decalX + 'px)'
            );
          } else {
            this.lastAcc = 0;
          }
        }
      } else {
        this.decalY = this.marginTop + diffY;
      }
    }
  }
  processMouseUp(event: any) {
    if (this.dragStarted) {
      this.posX = 0;
      this.dragStarted = false;
      if (this.dispoResults.length > 1) {
        this.marginLeft = this.resetDecalX ? this.decalX : this.marginLeft;
        this.resetDecalX = false;
        this.decalX = 0;
        if (
          this.sliderType === 'scroll' &&
          this.lastAcc !== 0 &&
          !this.isDesktop
        ) {
          this.decelerateAnim();
        }
        if (this.sliderType === 'swipe' && !this.isDesktop) {
          this.goToClosestCard();
        }
      }
      if (this.decalY !== 0) {
        if (this.decalY > 100) {
          // descend les cards
          this.reduceCards();
        } else if (Math.abs(this.decalY) > 25) {
          // monte les cards
          this.showResultsFullCards = true;
          this.cdr.detectChanges();
        }
      }
    }
  }

  goToClosestCard(forceIndex?: any) {
    const indexDetails =
      !forceIndex && forceIndex !== 0
        ? Math.abs(this.marginLeft) / this.cardsWidth
        : forceIndex;
    let roundedIndex =
      this.lastAcc > 0 ? Math.round(indexDetails) : Math.ceil(indexDetails);
    // console.log(indexDetails, roundedIndex);
    const swipeDecalX =
      roundedIndex > 0 ? Math.abs(roundedIndex - indexDetails) : indexDetails;
    const swipeDecalXLimit =
      this.lastAcc > 0
        ? window.innerWidth > this.cardsWidth * 1.5
          ? 0
          : 0.25
        : window.innerWidth > this.cardsWidth * 1.5
          ? 0.8
          : 0.4;
    // console.log(swipeDecalX, swipeDecalXLimit);
    // console.log('indexDetails', indexDetails);
    // console.log('lastAcc', this.lastAcc);
    if (swipeDecalX > swipeDecalXLimit) {
      if (indexDetails > 1) {
        roundedIndex =
          this.lastAcc >= 0
            ? Math.ceil(indexDetails)
            : Math.floor(indexDetails);
      } else {
        roundedIndex =
          this.lastAcc >= 0 ? Math.ceil(swipeDecalX) : Math.floor(swipeDecalX);
      }
    }
    if (this.dispoResults.length === 1) {
      roundedIndex = 0;
    }
    // console.log(roundedIndex);
    roundedIndex = roundedIndex < 0 ? 0 : roundedIndex;
    // set active card
    this.lastActiveCard =
      !this.lastActiveCard || this.lastActiveCard === 0
        ? 0
        : this.lastActiveCard;
    this.dispoResults[this.lastActiveCard].active = false;
    this.dispoResults[roundedIndex].active = true;
    this.lastActiveCard = roundedIndex;

    this.updateMarker();

    this.marginLeft =
      roundedIndex === this.dispoResults.length - 1
        ? this.limitSliderX
        : roundedIndex * this.cardsWidth * -1 +
          (window.innerWidth - (this.cardsWidth + 12)) / 2;
    this.marginLeft = this.marginLeft > 0 ? 0 : this.marginLeft;

    this.cdr.detectChanges();

    this.renderer.setStyle(
      this.sliderResults.nativeElement,
      'transition',
      'transform .3s ease-out'
    );
    this.renderer.setStyle(
      this.sliderResults.nativeElement,
      'transform',
      'translateX(' + this.marginLeft + 'px)'
    );
    if (!this.dragStarted) {
      setTimeout(() => {
        if (!this.dragStarted) {
          this.moveMapToCardLocation(this.dispoResults[roundedIndex].data);
        }
      }, 300);
    }
  }

  centerCardLocationOnMap(index: any) {
    // console.log('centerCardLocationOnMap');
    // console.log('lastAcc', this.lastAcc);
    // console.log('dragStarted', this.dragStarted);
    if (
      (!this.isDesktop && this.lastAcc === 0 && !this.dragStarted) ||
      this.isDesktop
    ) {
      if (!!index || index === 0) {
        // console.log('centerCardLocationOnMap index', index);
        this.lastActiveCard =
          !this.lastActiveCard || this.lastActiveCard === 0
            ? 0
            : this.lastActiveCard;
        this.dispoResults[this.lastActiveCard].active = false;
        this.lastActiveCard = index;
        this.dispoResults[index].active = true;

        this.updateMarker();

        if (!this.isDesktop) {
          if (this.dispoResults.length === 1) {
            this.centerCardResult();
          } else {
            this.goToClosestCard(index);
          }
        } else {
          this.moveMapToCardLocation(this.dispoResults[index].data);
          const parent = document.getElementById('results-desktop');
          const elt: any = parent.getElementsByClassName('card-result')[index];
          setTimeout(() => {
            this.resultsDesktop.nativeElement.scrollTop = elt.offsetTop - 16;
          }, 0);
        }
      }
    }
  }

  moveMapToCardLocation(location: any) {
    const lat = !!location.location
      ? location.location.coordinates[1]
      : location.coordinates[1];
    const lng = !!location.location
      ? location.location.coordinates[0]
      : location.coordinates[0];
    this.centerMap(lat, lng);
  }

  decelerateAnim() {
    const decelerateReducer =
      window.innerWidth > 768 ? 20 : window.innerWidth > 375 ? 30 : 40;
    const lastAccReducer =
      window.innerWidth > 768 ? 1.5 : window.innerWidth > 375 ? 1.25 : 1;
    // console.log(decelerateReducer, lastAccReducer);
    this.lastAcc = this.lastAcc / lastAccReducer;
    this.decelerateAnimInterval = setInterval(() => {
      // const decelerateValue = (Math.abs(this.lastAcc / decelerateReducer) > 1) ? this.lastAcc / decelerateReducer : (this.lastAcc > 0) ? 1 : -1;
      const decelerateValue = this.lastAcc / decelerateReducer;
      if (this.lastAcc !== 0) {
        this.lastAcc -= decelerateValue;
        this.marginLeft -= this.lastAcc;
        this.lastAcc = Math.abs(this.lastAcc) <= 1 ? 0 : this.lastAcc;
        if (this.marginLeft >= 0) {
          this.marginLeft = 0;
          this.lastAcc = 0;
        }
        if (this.marginLeft <= this.limitSliderX) {
          this.marginLeft = this.limitSliderX;
          this.lastAcc = 0;
        }
        this.renderer.setStyle(
          this.sliderResults.nativeElement,
          'transform',
          'translateX(' + this.marginLeft + 'px)'
        );
      } else {
        clearInterval(this.decelerateAnimInterval);
      }
    }, 20);
  }

  switchCardReduction() {
    this.showResultsFullCards = !this.showResultsFullCards;
    this.cdr.detectChanges();
  }

  reduceCards() {
    if (this.showResultsFullCards) {
      this.showResultsFullCards = false;
      this.cdr.detectChanges();
    }
  }

  setOffersDisplay(offersType) {
    if (offersType === this.switchOffers) {
      return;
    }
    this.switchOffers = offersType;
    this.gearboxType = this.switchOffers.toLowerCase();

    this.showResults = false;
    this.dispoResults = [];
    this.lastActiveMarker = null;
    this.deleteMarkers();
    this.fetchLocations();

    if (!!this.userAddress) {
      this.geoCoding();
    }

    this.cdr.detectChanges();
  }

  triggerCardActionById(link: any) {
    if (link === 'marketingRegular') {
      this.openModalPack(
        {
          item_id: 'big_pack',
          item_promo_type: 'regular',
          item_location_id: 'marketingregular',
          item_location_format: 'modale',
          item_promo_content: 'reserved',
        },
        'marketingRegular'
      );
    } else if (link === 'marketingRegister') {
      this.openModalPack(null, 'marketingRegister');
    } else {
      if (typeof link === 'object') {
        if (link.link === 'permis') {
          const item = {
            item_id: 'big_pack',
            item_promo_type: 'regular',
            item_location_id: 'code_top',
            item_location_format: 'promo_card',
            item_promo_content: 'choucoute',
          };

          this.statsService.send({
            name: 'item:clicked',
            payload: {
              item: item,
            },
          });
        }
        this.openLink(link.link);
      }
    }
  }

  async openModalPack(
    bannerInfo?: any,
    type?: string,
    noClose = false,
    customClass = ''
  ) {
    // evs-global.scss : small-modal | medium-modal
    if (!type) {
      type = 'marketingRegular';
    }
    let props;
    if (!!bannerInfo) {
      props = {
        type: type,
        bannerInfo: {
          item_id: bannerInfo.itemId,
          item_promo_type: bannerInfo.itemPromoType,
          item_location_id: bannerInfo.itemLocationId,
          item_location_format: bannerInfo.itemLocationFormat,
          item_promo_content: bannerInfo.itemPromoContent,
        },
      };
    } else {
      props = {
        type: type,
        bannerInfo: null,
      };
    }
    let modal;
    if (noClose) {
      modal = await this.modalController.create({
        component: ModalMarketingComponent,
        cssClass: customClass,
        backdropDismiss: false,
        componentProps: props,
      });
    } else {
      modal = await this.modalController.create({
        component: ModalMarketingComponent,
        cssClass: customClass,
        componentProps: props,
      });
    }
    return await modal.present();
  }

  async openModalIframe(url: any, type?: string, noClose = true) {
    if (!type) {
      type = 'iframe';
    }
    let modal;
    if (noClose) {
      modal = await this.modalController.create({
        component: ModalIframeComponent,
        backdropDismiss: false,
        cssClass: 'custom-modal-iframe',
        componentProps: {
          type: type,
          url: url,
        },
      });
    } else {
      modal = await this.modalController.create({
        component: ModalIframeComponent,
        cssClass: 'custom-modal-iframe',
        componentProps: {
          type: type,
          url: url,
        },
      });
    }
    return await modal.present();
  }

  closeModals() {
    const modals = document.getElementsByTagName('ion-modal');
    while (modals.length > 0) {
      modals[0].parentNode.removeChild(modals[0]);
    }
  }

  showToasterInvalidAddress() {
    this.addressInvalid = true;
    this.cdr.detectChanges();
    setTimeout(() => {
      this.hideToasterInvalidAddress();
      this.resetInput();
    }, 1000);
  }

  hideToasterInvalidAddress() {
    this.addressInvalid = false;
    this.cdr.detectChanges();
  }

  showModalNoResults() {
    this.modalNoResults = true;
    this.cdr.detectChanges();
  }

  hideModalNoResults() {
    this.modalNoResults = false;
    this.cdr.detectChanges();
    this.resetInput();
  }

  showModalNoGeoloc() {
    this.modalNoGeoloc = true;
    this.geolocationLoading = false;
    this.cdr.detectChanges();
  }

  hideModalNoGeoloc() {
    this.modalNoGeoloc = false;
    this.geolocationLoading = false;
    this.cdr.detectChanges();
  }

  showModalLocationError() {
    this.modalLocationError = true;
    this.geolocationLoading = false;
    this.cdr.detectChanges();
  }

  hideModalLocationError() {
    this.modalLocationError = false;
    this.geolocationLoading = false;
    this.cdr.detectChanges();
  }

  showModalSearchError() {
    this.modalSearchError = true;
    this.geolocationLoading = false;
    this.cdr.detectChanges();
  }

  hideModalSearchError() {
    this.modalSearchError = false;
    this.geolocationLoading = false;
    this.cdr.detectChanges();
  }

  goConfidentialite() {
    this.openLink('politiqueConfidentialite', { target: '_system' });
  }

  getPackPermisUrl() {
    let offerFound = null;
    if (
      !this.student?.driving_department ||
      (!!this.student?.driving_department &&
        !this.student?.driving_department?.pricing_zone_id)
    ) {
      if (!!this.offers && this.offers.length > 0 && !this.fetchOffersFailed) {
        const offersFound = this.offers.filter(
          elt => elt.offer_type === 'big_pack'
        );
        const minOffer = offersFound.reduce((prev, current) =>
          prev.amount < current.amount ? prev : current
        );
        offerFound = !!minOffer?.id ? minOffer.id : offerFound;
      }
    } else {
      if (
        !!this.studentCustomOffers &&
        this.studentCustomOffers.length > 0 &&
        !this.fetchStudentCustomOffersFailed
      ) {
        const offersFound = this.studentCustomOffers.find(
          elt => elt.offer_type === 'big_pack'
        );
        offerFound = !!offersFound?.id ? offersFound.id : offerFound;
      }
    }
    // for (const offer of this.offers) {
    //   if (offer.offer_type === 'big_pack') {
    //     offerFound = offer.id;
    //   }
    // }
    if (!!offerFound) {
      if (this.student.isGuest()) {
        this.statsService.send({ name: 'add_to_cart:big_pack' });
      } else {
        this.statsService.send({ name: 'initiate_checkout:big_pack' });
      }
      this.packPermisUrl =
        'https://www.envoituresimone.com/tunnel?offer_id=' + offerFound;
    }
  }

  async openLink(link, options: any = {}) {
    let callbackUrl = null;

    if (link === 'packPermisUrl') {
      const domain = environment.env === 'production' ? 'app' : 'app-dev';
      if (
        this.switchOffers === 'BVM' ||
        (this.switchOffers === 'ALL' &&
          options?.gearboxTypeOnLocation === 'BVM')
      ) {
        this.packPermisUrl = `https://${domain}.envoituresimone.com/tunnel-paiement/BVM/big_pack`;
      }
      if (
        this.switchOffers === 'BVA' ||
        (this.switchOffers === 'ALL' &&
          options?.gearboxTypeOnLocation === 'BVA')
      ) {
        this.packPermisUrl = `https://${domain}.envoituresimone.com/tunnel-paiement/BVA/big_pack`;
      }
      if (
        this.switchOffers === 'ALL' &&
        options?.gearboxTypeOnLocation === 'ALL'
      ) {
        this.packPermisUrl =
          'https://www.envoituresimone.com/permis-de-conduire';
      }

      top.window.location.href = this.packPermisUrl;
      return false;
    } else if (link === 'tunnel-permis') {
      let offerFound = null;
      if (
        !this.student?.driving_department ||
        (!!this.student?.driving_department &&
          !this.student?.driving_department?.pricing_zone_id)
      ) {
        if (
          !!this.offers &&
          this.offers.length > 0 &&
          !this.fetchOffersFailed
        ) {
          const offersFound = this.offers.filter(
            elt =>
              elt.offer_type === 'big_pack' && elt.offer_credit_type === 'BVM'
          );
          const minOffer = offersFound.reduce((prev, current) =>
            prev.amount < current.amount ? prev : current
          );
          const offerId = !!minOffer && !!minOffer.id ? minOffer.id : null;
          offerFound = !!minOffer ? minOffer : offerFound;
        }
      } else {
        if (
          !!this.studentCustomOffers &&
          this.studentCustomOffers.length > 0 &&
          !this.fetchStudentCustomOffersFailed
        ) {
          const offersFound = this.studentCustomOffers.find(
            elt =>
              elt.offer_type === 'big_pack' && elt.offer_credit_type === 'BVM'
          );
          offerFound = !!offersFound ? offersFound : offerFound;
        }
      }
      // for (const offer of this.offers) {
      //   if (offer.offer_type === 'big_pack') {
      //     offerFound = offer.id;
      //   }
      // }
      if (!!offerFound) {
        if (this.student.isGuest()) {
          this.statsService.send({ name: 'add_to_cart:big_pack' });
        } else {
          this.statsService.send({ name: 'initiate_checkout:big_pack' });
        }
        link = `tunnel-paiement/${offerFound.offer_credit_type}/${offerFound.offer_type}`;
      } else {
        link = 'permis';
      }
    }

    callbackUrl = await this.navigationService.open(link, options);
    if (!!callbackUrl && callbackUrl !== '') {
      this.openModalIframe(callbackUrl);
    }
  }
}
